import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  DISCORD_URL,
  EMAIL_SUPPORT,
  LINKEDIN_URL,
  X_URL,
  YOUTUBE_URL,
} from '@app/config';

@Component({
  selector: 'app-contact-methods-section',
  imports: [],
  templateUrl: './contact-methods-section.component.html',
  styleUrl: './contact-methods-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactMethodsSectionComponent {
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly discordUrl = DISCORD_URL;
  protected readonly xUrl = X_URL;
  protected readonly linkedinUrl = LINKEDIN_URL;
  protected readonly youtubeUrl = YOUTUBE_URL;
}
